import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

// "index" page to avoid issues with router
import { version } from "env";
import technicianSettings from "helpers/technicianSettings";
import { UserConsentTypeEnum } from "operations/schema/schema";
import { useAppSelector } from "store";
import { isPartnerView } from "store/root.store";
import { selectUser } from "store/slices/user.store";
import { Userpilot } from "userpilot";

export const UserpilotHandler: FC = () => {
  const userVar = useAppSelector(selectUser);
  const location = useLocation();
  const partnerView = useAppSelector(isPartnerView);

  useEffect(() => {
    Userpilot.reload();
  }, [location]);

  useEffect(() => {
    if (
      !partnerView &&
      userVar &&
      userVar.email &&
      userVar.userConsents.find((x) => x.type === UserConsentTypeEnum.Userpilot && x.accepted)
    ) {
      Userpilot.identify(userVar.email, {
        email: userVar.email,
        company: {
          id: window.location.hostname,
          name: userVar.companyName,
          created_at: "2024-06-28",
        },
        Name: userVar.fullName,
        Email: userVar.email,
        Company: userVar.companyName,
        TechnicianId: userVar.technicianId,
        TechnicianGuid: userVar.technicianGuid,
        TechnicianNo: userVar.technicianNo,
        EvaticMobileVersion: version(),
        AppName: "Mobile",
        EngineerSettings: {
          AllowChangeInvoiceType: technicianSettings.allowChangeInvoiceType,
          AllowNegativeStock: technicianSettings.allowNegativeStock,
          SyncSalesPrice: technicianSettings.syncSalesPrice,
          SyncCostPrice: technicianSettings.syncCostPrice,
          IsAllowedMobileMachineEdit: technicianSettings.isAllowedMobileMachineEdit,
          CanCreateJob: technicianSettings.canCreateJob,
          SimplePlannerAccess: technicianSettings.simplePlannerAccess,
          AdvancedPlannerAccess: technicianSettings.advancedPlannerAccess,
          RequireEngineerSignature: technicianSettings.requireTechnicianSignature,
          RequiredSolutionDescription: technicianSettings.requiredSolutionDescription,
          SendMailToCustomer: technicianSettings.sendMailToCustomer,
        },
      });
    } else {
      Userpilot.anonymous();
    }
  }, [partnerView, userVar]);

  return <></>;
};
